<!-- tabla inicial -->
<app-lfsa-card *ngIf="mostrarGrid" [innTemplate]="enviarTemplate" [titulo]="'Lista de Cobros'"></app-lfsa-card>

<ng-template #enviarTemplate>
  <div class="container">
    <!-- <div class="row">
        <div class="col-md-12">
            <div class="form-group col-12">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarAll"
                    id="quickFilter " (keyup)="onQuickFilterChangedAll() " #quickFilterAll />
            </div>
        </div>
    </div> -->
    <div class="row">
      <ag-grid-angular #agGrid (gridReady)="onGridReadyAll($event)" [columnDefs]="columnDefsAll "
                       [floatingFilter]="true" [frameworkComponents]="frameworkComponents "
                       [ngStyle]="cobroAutoModulo.agGrid.style"
                       [paginationPageSize]="cobroAutoModulo.agGrid.paginacion" [pagination]="true"
                       [rowData]="rowDataAll"
                       [rowSelection]="rowSelectionAll" class="{{cobroAutoModulo.agGrid.class}}"
                       id="{{cobroAutoModulo.agGrid.id}}">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<!-- <div class="row col-md-12 animated fadeInRight" *ngIf="mostrarGrid">
    <h2 class="container float-left">Lista de Cobros</h2>
    <hr/>
    <div class="container">
        <div class="row">
            <div class="row col 12">
              <div class="form-group col-12">
              <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarAll" id="quickFilter " (keyup)="onQuickFilterChangedAll() " #quickFilterAll/>
              </div>
            </div>
        </div>
        <ag-grid-angular
        class="{{cobroAutoModulo.agGrid.class}}" #agGrid
        [ngStyle] = "cobroAutoModulo.agGrid.style"
        id="{{cobroAutoModulo.agGrid.id}}"
        paginationPageSize ="{{cobroAutoModulo.agGrid.paginacion}}"
        [pagination]="true"

        [frameworkComponents]="frameworkComponents "
        [columnDefs]="columnDefsAll "
        [rowSelection]="rowSelectionAll"
        [rowData]="rowDataAll"
        (gridReady)="onGridReadyAll($event)">
        </ag-grid-angular>
    </div>
</div> -->

<!-- tabla procesar -->
<app-lfsa-card *ngIf="!mostrarGrid" [innTemplate]="enviarTemplateConsulta" [titulo]="'Cliente'"></app-lfsa-card>

<ng-template #enviarTemplateConsulta>
  <h5><b>Cliente:</b> {{ dataCliente.dscaCliente }}</h5>
  <h5><b>Cliente Vinculado:</b> {{ dataCliente.clientVinculado ? 'SI' : 'No' }}</h5>
  <h5><b>Cliente Padre:</b> {{ dataCliente.dscaClientePadre }}</h5>
  <h5><b>N° Asiento Contable:</b> {{ dataCliente.noAsiento }}</h5>
  <h5 *ngIf="dataCliente.numCheque"><b>N° Cheque:</b> {{ dataCliente.numCheque }}</h5>
  <h5><b>N° Referencia Bancaria:</b> {{ dataCliente.referencia }}</h5>
  <h5><b>Fecha:</b> {{ dataCliente.fechaHora.substring(0, 10) }}</h5>
  <h5><b>Hora:</b> {{ dataCliente.fechaHora.substring(11, 19) }}</h5>
  <br>
  <div class="row col 12">
    <div class="form-group col-3">
      <br>
      <button (click)="regresarGrid()" class="btn btn-outline-danger btn-block">Regresar</button>
    </div>
    <div class="form-group col-3">
      <br>
      <button (click)="descargar()" class="{{ DAT_BTNCSS.primary}}">{{ DAT_BTNS.descargar }}</button>
    </div>
  </div>
  <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs "
                   [floatingFilter]="true" [frameworkComponents]="frameworkComponents "
                   [ngStyle]="cobroAutoModulo.agGrid.style"
                   [paginationPageSize]="cobroAutoModulo.agGrid.paginacion" [pagination]="true" [rowData]="rowData "
                   [rowSelection]="rowSelection " class="{{cobroAutoModulo.agGrid.class}}"
                   id="{{cobroAutoModulo.agGrid.id}}">
  </ag-grid-angular>
</ng-template>

<!-- <div class="row col-md-12 animated fadeInRight" *ngIf="!mostrarGrid">
    <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <strong>Cliente</strong>
          </div>
           <div class="card-body">
                <h5><b>Cliente:</b> {{ dataCliente.dscaCliente }}</h5>
                <h5><b>Cliente Vinculado:</b> {{ dataCliente.clientVinculado ? 'SI' : 'No' }}</h5>
                <h5><b>Cliente Padre:</b> {{ dataCliente.dscaClientePadre }}</h5>
                <h5><b>N° Asiento Contable:</b> {{ dataCliente.noAsiento }}</h5>
                <h5 *ngIf="dataCliente.numCheque" ><b>N° Cheque:</b> {{ dataCliente.numCheque }}</h5>
                <h5><b>N° Referencia Bancaria:</b> {{ dataCliente.referencia }}</h5>
                <h5><b>Fecha:</b> {{ dataCliente.fechaHora.substring(0,10) }}</h5>
                <h5><b>Hora:</b> {{ dataCliente.fechaHora.substring(11,19) }}</h5>
            </div>
        </div>
    </div>
    <div class="row col 12">
        <div class="form-group col-3">
            <br>
            <button class="btn btn-outline-danger btn-lg btn-block" (click)="regresarGrid()">Regresar</button>
        </div>
        <div class="form-group col-3">
            <br>
            <button class="{{ DAT_BTNCSS.primarylg}}" (click)="descargar()">{{ DAT_BTNS.descargar }}</button>
        </div>
    </div>
    <ag-grid-angular
    class="{{cobroAutoModulo.agGrid.class}}" #agGrid
    [ngStyle] = "cobroAutoModulo.agGrid.style"
    id="{{cobroAutoModulo.agGrid.id}}"
    paginationPageSize ="{{cobroAutoModulo.agGrid.paginacion}}"
    [pagination]="true"

    [frameworkComponents]="frameworkComponents "
    [columnDefs]="columnDefs "
    [rowSelection]="rowSelection "
    [rowData]="rowData "
    (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>
   -->
